export default {
    url: '/courses',
    resolve: {
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        },
        sites: (SiteResource) => SiteResource.query({ reportUserCourseProgressSites: true, pageSize: 0 }).$promise
    },
    template: '<reports-courses classifiers="vm.classifiers" sites="vm.sites"/>',
    controller (classifiers, sites) {
        this.classifiers = classifiers;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/courses/index.js